// source: api/dashboard/v2/improvement_message.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

goog.exportSymbol('proto.improvement_message.Improvements', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.improvement_message.Improvements = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.improvement_message.Improvements, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.improvement_message.Improvements.displayName = 'proto.improvement_message.Improvements';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.improvement_message.Improvements.prototype.toObject = function(opt_includeInstance) {
  return proto.improvement_message.Improvements.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.improvement_message.Improvements} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.improvement_message.Improvements.toObject = function(includeInstance, msg) {
  var f, obj = {
    averageHazardousMovementValue: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    averageHazardousMovementFrequencyChange: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    hazardousMovementRatioValue: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
    hazardousMovementRatioChange: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
    debugInfo: jspb.Message.getFieldWithDefault(msg, 5, ""),
    initialHazardsPerHour: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
    currentHazardsPerHour: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
    hazardsPerHourImprovement: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
    hazardsPerHourChange: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
    totalDuration: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.improvement_message.Improvements}
 */
proto.improvement_message.Improvements.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.improvement_message.Improvements;
  return proto.improvement_message.Improvements.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.improvement_message.Improvements} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.improvement_message.Improvements}
 */
proto.improvement_message.Improvements.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAverageHazardousMovementValue(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAverageHazardousMovementFrequencyChange(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setHazardousMovementRatioValue(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setHazardousMovementRatioChange(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDebugInfo(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setInitialHazardsPerHour(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCurrentHazardsPerHour(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setHazardsPerHourImprovement(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setHazardsPerHourChange(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTotalDuration(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.improvement_message.Improvements.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.improvement_message.Improvements.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.improvement_message.Improvements} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.improvement_message.Improvements.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAverageHazardousMovementValue();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getAverageHazardousMovementFrequencyChange();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getHazardousMovementRatioValue();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getHazardousMovementRatioChange();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getDebugInfo();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getInitialHazardsPerHour();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getCurrentHazardsPerHour();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = message.getHazardsPerHourImprovement();
  if (f !== 0.0) {
    writer.writeDouble(
      8,
      f
    );
  }
  f = message.getHazardsPerHourChange();
  if (f !== 0.0) {
    writer.writeDouble(
      9,
      f
    );
  }
  f = message.getTotalDuration();
  if (f !== 0.0) {
    writer.writeDouble(
      10,
      f
    );
  }
};


/**
 * optional double average_hazardous_movement_value = 1;
 * @return {number}
 */
proto.improvement_message.Improvements.prototype.getAverageHazardousMovementValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.improvement_message.Improvements} returns this
 */
proto.improvement_message.Improvements.prototype.setAverageHazardousMovementValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double average_hazardous_movement_frequency_change = 2;
 * @return {number}
 */
proto.improvement_message.Improvements.prototype.getAverageHazardousMovementFrequencyChange = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.improvement_message.Improvements} returns this
 */
proto.improvement_message.Improvements.prototype.setAverageHazardousMovementFrequencyChange = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double hazardous_movement_ratio_value = 3;
 * @return {number}
 */
proto.improvement_message.Improvements.prototype.getHazardousMovementRatioValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.improvement_message.Improvements} returns this
 */
proto.improvement_message.Improvements.prototype.setHazardousMovementRatioValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double hazardous_movement_ratio_change = 4;
 * @return {number}
 */
proto.improvement_message.Improvements.prototype.getHazardousMovementRatioChange = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.improvement_message.Improvements} returns this
 */
proto.improvement_message.Improvements.prototype.setHazardousMovementRatioChange = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional string debug_info = 5;
 * @return {string}
 */
proto.improvement_message.Improvements.prototype.getDebugInfo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.improvement_message.Improvements} returns this
 */
proto.improvement_message.Improvements.prototype.setDebugInfo = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional double initial_hazards_per_hour = 6;
 * @return {number}
 */
proto.improvement_message.Improvements.prototype.getInitialHazardsPerHour = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.improvement_message.Improvements} returns this
 */
proto.improvement_message.Improvements.prototype.setInitialHazardsPerHour = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional double current_hazards_per_hour = 7;
 * @return {number}
 */
proto.improvement_message.Improvements.prototype.getCurrentHazardsPerHour = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.improvement_message.Improvements} returns this
 */
proto.improvement_message.Improvements.prototype.setCurrentHazardsPerHour = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional double hazards_per_hour_improvement = 8;
 * @return {number}
 */
proto.improvement_message.Improvements.prototype.getHazardsPerHourImprovement = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.improvement_message.Improvements} returns this
 */
proto.improvement_message.Improvements.prototype.setHazardsPerHourImprovement = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional double hazards_per_hour_change = 9;
 * @return {number}
 */
proto.improvement_message.Improvements.prototype.getHazardsPerHourChange = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.improvement_message.Improvements} returns this
 */
proto.improvement_message.Improvements.prototype.setHazardsPerHourChange = function(value) {
  return jspb.Message.setProto3FloatField(this, 9, value);
};


/**
 * optional double total_duration = 10;
 * @return {number}
 */
proto.improvement_message.Improvements.prototype.getTotalDuration = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.improvement_message.Improvements} returns this
 */
proto.improvement_message.Improvements.prototype.setTotalDuration = function(value) {
  return jspb.Message.setProto3FloatField(this, 10, value);
};


goog.object.extend(exports, proto.improvement_message);
